import { Component } from "../Component";
import { Vector2 } from "../Math/Vector2";

export class Circle extends Component {
    mouseLocation: Vector2 | undefined;

    constructor(public center: Vector2, public radius: number, public fill: boolean = false, public color: string = 'white') {
        super();
    }

    public draw(ctx: CanvasRenderingContext2D) {
        super.draw(ctx);

        ctx?.beginPath();
        ctx?.arc(this.center.x, this.center.y, this.radius, 0, Math.PI * 2);

        ctx?.stroke();

        if(this.fill) {
            ctx.fillStyle = this.color;
            ctx.fill();
        }

    }
}